import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import { routes, scrollBehavior, setupRouterGuards } from './router'
import { createI18nInstance } from './i18n'
import './app.css'

// NB : la liste des routes prérendues vit dans seo.routes.mjs
// (consommée par vite.config.js → ssgOptions.includedRoutes).
export const createApp = ViteSSG(
  App,
  {
    routes,
    scrollBehavior,
    base: import.meta.env.BASE_URL
  },
  ({ app, router, isClient }) => {
    const i18n = createI18nInstance()
    app.use(i18n)
    setupRouterGuards(router, i18n)

    // Sentry : client uniquement, chargé en différé pour ne pas retarder
    // l'hydratation (le SDK pèse lourd et n'apporte rien au first paint).
    if (isClient) {
      import('@sentry/vue').then((Sentry) => {
        Sentry.init({
          app,
          dsn: 'https://0a65a55c58e5676f2f88ec2cd5ce73fb@o1267300.ingest.us.sentry.io/4510855925137408',
          sendDefaultPii: true
        })
      })
    }
  }
)
